import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import './index.scss';

const NotFound = ({ className }) => {
  let loggedIn = useSelector(state => state.user.loggedIn);
  return (
    <div className={`not-found d-flex flex-column flex-fill align-items-center justify-content-center ${className}`}>
      <div className="inner">
        <h2>404</h2>
        <h3>Page Not Found!</h3>
        <p>Oops! The page you were looking for doesn't exist.</p>
        <Link to="/" className="btn btn-primary">
          Back to {loggedIn ? <span>home</span> : <span>Login </span>}
        </Link>
      </div>
    </div>
  );
}

export default NotFound;